import { defineComponent } from 'vue';
import CalendarIcon from '../../../../assets/icons/calendar.svg.js';
import __vue_component__ from '../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import { orderFlowNewDraftOrderRoute } from '../../../../router/routes/orderFlow/locations.js';
import { isPatientUser } from '../../../../store/helpers.js';

var script = defineComponent({
    name: 'EmptyOrdersList',
    components: {
        ButtonComponent: __vue_component__,
        CalendarIcon,
    },
    props: {
        entity: {
            type: String,
            default: 'orders',
        },
    },
    setup() {
        const isPatientApp = isPatientUser();
        const toRoute = orderFlowNewDraftOrderRoute();
        return { isPatientApp, toRoute };
    },
});

export { script as default };
